import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { BrowserRouter } from "react-router";
import { QueryProvider } from "@/providers/query-provider";
import { useAuth } from "@/store";
import { TourProvider } from "@/components/onboarding/tour-provider";
import { AppRoutes } from "./router";
import "./index.css";
export function App() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <QueryProvider><BrowserRouter><TourProvider><AppRoutes /></TourProvider></BrowserRouter></QueryProvider>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp() {
  useAuth.getState().bootstrap();
}
export default App;